export default "__VITE_ASSET__c1812b91__"